module.exports = __webpack_public_path__ + "static/media/brego3595.9edfc7a8.jpg";